import { createRef, forwardRef, Fragment, memo, useRef } from 'react';

import classNames from 'classnames';

import { useUniqueKey } from '@hsp/react-hooks';

import { IStatBoxProps } from 'types/components/index';

import { Box } from './components';

import cssClasses from './stat-box.module.scss';

const StatBox = forwardRef<HTMLDivElement, IStatBoxProps>(
  ({ className, boxes, loading = false, size, ...props }, ref) => {
    const refs = useRef([]);
    const uniqueKey = useUniqueKey();

    refs.current = boxes.map((_, i) => refs.current[i] ?? createRef());

    return (
      <Fragment>
        <div
          {...props}
          className={classNames(className, cssClasses.statBoxWrapper, {
            [cssClasses.sm]: size === 'sm',
          })}
          ref={ref}>
          {boxes?.map((item, index) => (
            <Box
              className={classNames({
                'bg-blue-100': index === 2,
                'bg-blue-200': index === 0,
                'bg-gray-200': index === 3,
                'bg-green-300': index === 1,
              })}
              data={item}
              key={uniqueKey(item)}
              loading={loading}
              ref={refs.current[index]}
              size={size}
            />
          ))}
        </div>
      </Fragment>
    );
  }
);

StatBox.displayName = 'StatBox';

export default memo(StatBox);
